import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/MaximizingEfficiencyESPCoalHero-bg.webp";
import ArticleImg        from "../../asset/images/news/article-39.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .meec { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO ══ */
  .meec-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .meec-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .meec-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .meec-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .meec-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .meec-hero-divider {
    width: 575px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .meec-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .meec-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .meec-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .meec-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .meec-bc-item:hover { color: #EB2019; }
  .meec-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .meec-bc-sep img { width: 24px; height: 24px; display: block; }
  .meec-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .meec-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .meec-main-section { padding: 80px 0 120px 0; }
  .meec-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .meec-article { flex: 1; min-width: 0; }

  .meec-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .meec-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .meec-meta-item:last-child { border-right: none; padding-right: 0; }
  .meec-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .meec-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .meec-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .meec-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .meec-article-body p { margin-bottom: 20px; }
  .meec-article-body p:last-child { margin-bottom: 0; }

  .meec-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  .meec-h2-large {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin: 30px 0 20px 0; line-height: 140%; display: block;
  }

  .meec-article-body strong { font-weight: 600; color: #202020; }

  .meec-red-link {
    color: #EB2019; text-decoration: underline; font-weight: 600;
    display: block; margin-bottom: 20px;
  }
  .meec-red-link:hover { opacity: 0.8; }

  .meec-red-link-plain { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .meec-red-link-plain:hover { opacity: 0.8; }

  /* Hashtags */
  .meec-hashtags {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 700; color: #202020;
    line-height: 160%; margin-top: 15px;
  }

  /* ══ BOTTOM ROW ══ */
  .meec-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .meec-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .meec-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .meec-nav-btn:hover { color: #EB2019; }
  .meec-nav-btn img { width: 40px; height: 40px; display: block; }

  .meec-share-icons { display: flex; align-items: center; gap: 20px; }
  .meec-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .meec-share-icon:hover { opacity: 0.85; }
  .meec-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .meec-sidebar { flex: 0 0 475px; }
  .meec-sidebar-block { margin-bottom: 60px; }
  .meec-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .meec-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .meec-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .meec-recent-item:hover .meec-recent-title { color: #EB2019; }
  .meec-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .meec-recent-body { flex: 1; min-width: 0; }
  .meec-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .meec-social-icons { display: flex; align-items: center; gap: 30px; }
  .meec-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .meec-social-icon:hover { opacity: 0.8; }
  .meec-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .meec-hero             { height: 350px; }
    .meec-hero-content     { padding: 0 32px; }
    .meec-hero-title       { font-size: 30px; }
    .meec-hero-divider     { width: 100%; max-width: 479px; }
    .meec-breadcrumb       { padding: 24px 0 0 0; }
    .meec-breadcrumb-inner { padding: 0 32px; }
    .meec-inner            { padding: 0 32px; }
    .meec-main-section     { padding: 48px 0 60px 0; }
    .meec-main-row         { flex-direction: column; gap: 48px; }
    .meec-sidebar          { flex: none; width: 100%; }
    .meec-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .meec-hero             { height: 360px; }
    .meec-hero-content     { padding: 0 16px; }
    .meec-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .meec-hero-divider     { width: 100%; }
    .meec-hero-subtitle    { font-size: 14px; }
    .meec-breadcrumb       { padding: 30px 0 0 0; }
    .meec-breadcrumb-inner { padding: 0 16px; }
    .meec-bc-item          { font-size: 14px; gap: 14px; }
    .meec-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .meec-bc-sep img       { width: 22px; height: 22px; }
    .meec-inner            { padding: 0 16px; }
    .meec-main-section     { padding: 30px 0 60px 0; }
    .meec-main-row         { flex-direction: column; gap: 60px; }
    .meec-sidebar          { flex: none; width: 100%; }
    .meec-article-title    { font-size: 20px; margin-bottom: 15px; }
    .meec-article-body     { font-size: 14px; }
    .meec-article-body p   { margin-bottom: 15px; }
    .meec-article-body strong { font-size: 16px; }
    .meec-meta-item        { font-size: 14px; }
    .meec-meta-item:nth-child(3) { border-right: none; padding-right: 0px; }
    .meec-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .meec-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .meec-h2-large         { font-size: 20px; margin: 30px 0 0px 0; }
    .meec-hashtags         { margin-top: 30px; font-size: 14px; }
    .meec-nav-btn img      { width: 24px; height: 24px; }
    .meec-nav-btn          { font-size: 14px; }
    .meec-share-icon img   { width: 34px; height: 34px; }
    .meec-sidebar-title    { font-size: 20px; }
    .meec-bottom-nav       { gap: 20px; }
  }
`;

const recentPosts = [
   {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },

];

export default function MaximizingEfficiencyESPCoal() {
  return (
    <div className="meec">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="meec-hero">
        <img className="meec-hero-bg" src={HeroBgImg} alt="Maximizing Efficiency ESP Coal Power Plants Hero" />
        <div className="meec-hero-overlay" />
        <div className="meec-hero-content">
          <h1 className="meec-hero-title">
            Maximizing Efficiency: Best Practices for Maintaining Electrostatic Precipitators in Coal Power Plants
          </h1>
          <hr className="meec-hero-divider" />
          <p className="meec-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="meec-breadcrumb" aria-label="Breadcrumb">
        <div className="meec-breadcrumb-inner">
          <a href="/" className="meec-bc-item">Home</a>
          <span className="meec-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="meec-bc-item">News &amp; Updates</a>
          <span className="meec-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="meec-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="meec-main-section">
        <div className="meec-inner">
          <div className="meec-main-row">

            {/* ── ARTICLE ── */}
            <article className="meec-article">

              {/* Meta bar */}
              <div className="meec-meta-bar">
                <span className="meec-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="meec-meta-item"><img src={CalendarIcon} alt="date" /> October 4, 2024</span>
                <span className="meec-meta-item"><img src={ClockIconImg} alt="time" /> 5:33 am</span>
                <span className="meec-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="meec-article-title">
                Maximizing Efficiency: Best Practices for Maintaining Electrostatic Precipitators in Coal Power Plants
              </h1>

              {/* Body */}
              <div className="meec-article-body">

                <p><a href="#" className="meec-red-link-plain">Electrostatic precipitators</a> (ESPs) are essential in decreasing air pollution from coal power plants. As one of the most practical technologies for catching particulate matter from flue gases, sustaining ESPs at peak performance is crucial for maximizing efficiency and guaranteeing compliance with environmental ordinances.</p>

                {/* Article image */}
                <img className="meec-article-img" src={ArticleImg} alt="Maximizing Efficiency Electrostatic Precipitators Coal Power Plants" />

                <p>Here, we examine best practices for maintaining electrostatic precipitators in coal power plants to support and optimize their operation and extend their lifespan.</p>

                <span className="meec-h2">Best Practices for Maintaining Electrostatic Precipitators in Coal Power Plants</span>

                <p>Here, we examine best practices for maintaining electrostatic precipitators in coal power plants to support and optimize their operation and extend their lifespan.</p>

                <span className="meec-h2">Regular Inspections</span>

                <p>Periodic assessments are critical to the efficiency of electrostatic precipitators. For wear, erosion, or misalignment signs, inspect components such as discharge electrodes, collecting plates, and transformer rectifiers. Premature problem detection can control more significant issues, such as performance loss or unexpected downtime. Inspections should include visual checks, thermal imaging for electrical hot spots, and mechanical integrity evaluations to detect corrosion, warping, or electrical faults before they impact performance.</p>

                <span className="meec-h2">Proper Cleaning</span>

                <p>To ensure optimal performance, you should frequently remove dust, ash, and other particulates collected by the electrostatic precipitators. Automated rapping systems are typically used to dislodge collected dust from the plates. Ensuring these rapping systems function correctly is key to maintaining the ESP's efficiency. Cleaning intervals should be tailored to ash content and composition, and routine visual inspections can verify if re-entrainment of particles is occurring, which can degrade system performance.</p>

                <span className="meec-h2">Monitoring Electrical Performance</span>

                <p>The electrical systems of an ESP, including the transformer rectifiers, are critical to its operation. Regularly monitoring current and voltage levels helps ensure the ESP operates within optimal electrical parameters. Malfunctioning rectifiers or electrical imbalances can lead to inefficiencies in capturing particulates, resulting in higher emissions. Advanced power monitoring systems can log trends and detect anomalies, providing early warnings for components heading toward failure. Monitoring spark rates and corona power output can also help fine-tune ESP performance.</p>

                <span className="meec-h2">Optimizing Airflow</span>

                <p>Ensuring that airflow through the ESP is balanced is essential for maximizing particulate collection efficiency. Uneven airflow can result in underutilized areas of the ESP, reducing its overall effectiveness. Regularly monitoring and adjusting airflow settings can improve efficiency. Damaged or obstructed ductwork, fan performance issues, and changes in boiler operation can all impact airflow. Using Computational Fluid Dynamics (CFD) modeling during maintenance planning can help visualize flow distribution and inform targeted design or operational improvements.</p>

                <span className="meec-h2">Maintaining Control Systems</span>

                <p>Modern electrostatic precipitators rely on advanced control systems to adjust real-time operational parameters. These systems should be regularly updated and calibrated to ensure they provide accurate data and make optimal ESP adjustments. Investing in intelligent control systems can also help diagnose performance issues proactively before they become effective. Predictive algorithms, machine learning modules, and remote diagnostics tools can enhance control system responsiveness and reduce manual intervention.</p>

                <span className="meec-h2">Scheduled Downtime for Maintenance</span>

                <p>To evade expensive breakdowns, coal power plants should organize periodic maintenance shutdowns to perform in-depth assessments, cleaning, and restorations of their ESP systems. Proactive maintenance can control unanticipated failures and guarantee long-term functional efficiency. During these downtimes, maintenance teams should replace worn electrodes, check structural integrity, service transformer rectifiers, inspect insulation, and conduct high-voltage tests. Creating a standardized maintenance checklist ensures consistency across shutdowns and helps in documenting historical issues for future planning.</p>

                <span className="meec-h2-large">Additional Best Practices</span>

                <span className="meec-h2">Staff Training and Safety</span>

                <p>All personnel responsible for ESP operation and maintenance should receive proper training. This includes understanding the electrical hazards, safe lockout-tagout procedures, and correct maintenance routines. Inadequate training can lead to incorrect procedures or missed warning signs, resulting in performance decline or safety incidents.</p>

                <span className="meec-h2">Documentation and Record-Keeping</span>

                <p>Keeping detailed records of inspections, repairs, and operational data can offer valuable insights into system performance over time. These records help track recurring issues, identify trends, and support compliance with environmental reporting requirements. Digital maintenance management systems (CMMS) can streamline record-keeping and ensure tasks are completed on schedule.</p>

                <span className="meec-h2">Spare Parts Inventory</span>

                <p>Maintaining a stockpile of critical spare parts—such as rectifiers, insulators, rapping system components, and electrodes—can drastically reduce repair time during emergencies. Coordinating with suppliers for long lead-time items ensures that plant downtime is minimized when replacements are needed. By implementing these best practices, coal-fired power plants can not only extend the service life of their electrostatic precipitators but also maintain environmental compliance, reduce emissions, and optimize operational costs. A well-maintained ESP system directly contributes to plant reliability, regulatory adherence, and public health protection.</p>

                <span className="meec-h2">Final Thoughts</span>

                <p>Maintaining <a href="#" className="meec-red-link-plain">electrostatic precipitators (ESPs)</a> is vital for coal power plants' continued efficiency and reduction of environmental impact. By following best practices such as regular inspections, proper cleaning, electrical charge monitoring, and scheduled maintenance, coal power plants can optimize the performance of their wet ESPs and dry ESPs while ensuring compliance with stringent emissions standards.</p>

                <p>ESPs work by applying high voltage to create a corona discharge, which imparts a negatively charged field to particulate matter in the gas stream. This allows pollutants like lead oxide fumes emitted from combustion to be captured on the collection electrode, significantly reducing harmful emissions. Advanced solutions like the wet electrostatic precipitator are especially effective in handling flue gas and large gas volumes, ensuring efficient pollutant removal.</p>

                <p>For expert solutions and high-quality <strong>electrostatic precipitator</strong> maintenance, trust industry leaders like ADOR POWERTRON. With cutting-edge technology and professional care, your power plant can function efficiently and comply with environmental regulations.</p>

                <p>Contact us today for expert solutions and advanced technology to support your coal power plant operating at peak performance.</p>

                <a href="/contact-us" className="meec-red-link">Let's optimize your ESP systems together!</a>

                <p className="meec-hashtags"><strong>#ElectrostaticPrecipitators #CoalPowerPlants #PollutionControl #ESPMaintenance #EmissionReduction #EnergyEfficiency</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="meec-bottom-row">
                <div className="meec-bottom-nav">
                  <a href="/news/transformer-bushings-coal-power" className="meec-nav-btn">
                    <img src={PreviousIcon} alt="Previous" />
                    Previous
                  </a>
                  <a href="/news/switch-mode-power-supply-esp" className="meec-nav-btn">
                    Next
                    <img src={NextIcon} alt="Next" />
                  </a>
                </div>
                <div className="meec-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/electrostatic-precipitators-in-coal-power-plants/" className="meec-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Felectrostatic-precipitators-in-coal-power-plants%2F&mode=login" className="meec-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://www.linkedin.com/login/?session_redirect=https%3A%2F%2Fwww.linkedin.com%2FshareArticle%3Fmini%3Dtrue%26url%3Dhttps%3A%2F%2Fadorpowertron.com%2Felectrostatic-precipitators-in-coal-power-plants%2F%26title%3DElectrostatic%2520Precipitators%2520in%2520Coal%2520Power%2520Plants%2520%257C%2520Ador%26summary%3D%26source%3Dhttps%3A%2F%2Fadorpowertron.com%2Felectrostatic-precipitators-in-coal-power-plants%2F" className="meec-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="meec-sidebar">

              {/* Recent Posts */}
              <div className="meec-sidebar-block">
                <p className="meec-sidebar-title">Recent Posts</p>
                <div className="meec-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="meec-recent-item">
                      <img src={post.img} alt={post.title} className="meec-recent-img" />
                      <div className="meec-recent-body">
                        <span className="meec-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="meec-sidebar-block">
                <p className="meec-sidebar-title">Social Media</p>
                <div className="meec-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="meec-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="meec-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}